import LandingPage from '../containers/landing-page';
import Peers from '../containers/peer-listing';
import Checkins from '../containers/check-ins';
import Requests from '../containers/requests';
import Profile from '../containers/peer-profiles/profile';
import ContentReview from '../containers/peer-profiles/content-review';
import Peersona from '../containers/peer-profiles/peersona';
import Engagement from '../containers/peer-profiles/engagement';
import Connections from '../containers/peer-profiles/connections';
import Additional from '../containers/peer-profiles/Additional';
import Log from '../containers/peer-profiles/log';
import OnCall from '../containers/peer-profiles/on-call';
import MembersProfile from '../containers/members/profile';
import Members from '../containers/members';
import MemberConnections from '../containers/members/connections';
import MemberLog from '../containers/members/log';
import Calls from '../containers/connections';
import Stories from '../containers/stories';
import Topics from '../containers/topics';
import Clients from '../containers/clients';
import Packages from '../containers/clients/packages';
import Configure from '../containers/clients/configure';
import ClientResources from '../containers/clients/resources';
import Demographics from '../containers/client-configuration/engagement-details';
import EligibilityFile from '../containers/client-configuration/eligibilty-file';
import RichTextEditor from '../components/rich-text-editor/rich-text-editor';
import Reporting from '../containers/clients/reporting';
import TemplateComms from '../containers/templates/comms';
import Admins from '../containers/clients/admins';
import Tiers from '../containers/listener-tiers';
import TiersDetails from '../containers/listener-tiers/tier-details';
import Tags from '../containers/tags-management/tags';
import TagGroups from '../containers/tags-management/tag-groups';
import ProfileAudioReview from '../containers/peer-profiles/audio';
import ProfileVideoReview from '../containers/peer-profiles/video';
import Payout from '../containers/peer-profiles/payout';
import Resources from '../containers/resources';
import ContentLibrary from '../containers/content-library';
import AudioSamplesPage from '../containers/content-library/audio-samples';
import ResourceDetails from '../containers/resources/resource-details';
import GlobalDashboardPeers from '../containers/landing-page/global-dashboard-peers';
import GlobalDashboardTopics from '../containers/landing-page/global-dashboard-topics';
import GlobalDashboardNavigation from '../containers/landing-page/global-dashboard-navigation';
import blacklist from '../containers/user-safety/blacklist';
import CallerBlockList from '../containers/user-safety/caller-block-list';
import UserManagement from '../containers/user-safety/user-managment';
import Settings from '../containers/user-safety/settings';
import Users from '../containers/users';
import { SearchQueriesPage } from '../containers/search-queries/pages';
import PlusCarePage from '../containers/plus-care/plus-care';
import PlusCareContentPage from '../containers/plus-care/plus-care-content';
import { SSOConfiguration } from '../containers/clients/sso-configuration';
import { LinksPage } from '../containers/links/links';
import { ContentRecommendationsPage } from '../containers/content-recommendations/content-recommendations';
import { ROUTE_PATH } from './paths';
import PrivateRoute from './privateRoute';
import { publicRoutes } from './public-router';
import { Redirect, Route, Switch } from 'react-router';
import { clientAdminRoutes } from './clientadmin-router';
import { UserRole } from '../containers/navigation-bar/roles';
import MemberTOS from '../containers/text-blocks/members';
import ClientAdminTOS from '../containers/text-blocks/client-adminstrator';
import ListenerTOS from '../containers/text-blocks/listeners';
import VersionedAgreements from '../containers/text-blocks/versioned-records';
import Files from '../containers/files';
import AudioReview from '../containers/listener-reviewers/audio-review';
import VideoReview from '../containers/listener-reviewers/video-review';
import AvatarReview from '../containers/listener-reviewers/avatar-review';
import DisplayNameReview from '../containers/listener-reviewers/display-name-review';
import AboutMeReview from '../containers/listener-reviewers/about-me-review';
import BackgroundTagApproval from '../containers/listener-reviewers/background-tag-approval';
import CallReporting from '../containers/reports/call-reports/index';
import EngagementReporting from '../containers/reports/engagement-reports';
import ClientEngagementReporting from '../containers/reports/client-engagement-reports';
import FeatureFlagsPage from '../containers/feature-flags';
import PeerScheduleOverview from '../containers/peer-schedule/schedule-overview';
import EligibilityTool from '../containers/clients/eligibility-tool';
import ThemeConfiguration from '../containers/clients/landing-page-and-theme';
import DefaultThemeConfiguration from '../containers/clients/landing-page-and-theme/defaults';
import { AIPrompts } from '../containers/text-blocks/ai-prompts';
import { FiConcierge } from '../containers/text-blocks/fi-concierge';
import PeerScheduleHistory from '../containers/peer-schedule/schedule-history';
import PeersonaChatLogs from '../containers/peersona-chat-logs/index';
import { PeersonaCrisisDefaults } from '../containers/text-blocks/peersona-crisis-defaults';
import { ClientPeersonaConfig } from '../containers/clients/peersona-configuration';
import TAMUReport from '../containers/reports/tamu-report';
import PipelinesPage from '../containers/pipelines';
import PersonasCatalog from '../containers/personas';
import SharedRules from '../containers/personas/shared-rules';
import {
  PersonaOverview,
  PersonaClients,
  PersonaRules,
  PersonaEvals,
  PersonaPrompts,
  PersonaChat,
} from '../containers/personas/detail';

const adminRoutes = [
  {
    path: ROUTE_PATH.DASHBOARD,
    component: LandingPage,
  },
  {
    path: ROUTE_PATH.DASHBOARD_OVERVIEW,
    component: LandingPage,
  },
  {
    path: ROUTE_PATH.DASHBOARD_ENGAGEMENT,
    component: LandingPage,
  },
  {
    path: ROUTE_PATH.SEARCH_QUERIES,
    component: SearchQueriesPage,
  },
  {
    path: ROUTE_PATH.LINKS,
    component: LinksPage,
  },
  {
    path: ROUTE_PATH.CONTENT_RECOMMENDATIONS,
    component: ContentRecommendationsPage,
  },
  {
    path: ROUTE_PATH.PLUS_CARE,
    component: PlusCarePage,
  },
  {
    path: ROUTE_PATH.PLUS_CARE_CONTENT,
    component: PlusCareContentPage,
  },
  {
    path: ROUTE_PATH.DASHBOARD_TOPICS,
    component: GlobalDashboardTopics,
  },
  {
    path: ROUTE_PATH.DASHBOARD_PEERS,
    component: GlobalDashboardPeers,
  },
  {
    path: ROUTE_PATH.DASHBOARD_NAVIGATION,
    component: GlobalDashboardNavigation,
  },
  {
    path: ROUTE_PATH.PEERS,
    component: Peers,
  },
  {
    path: ROUTE_PATH.SCHEDULE_OVERVIEW,
    component: PeerScheduleOverview,
  },
  {
    path: ROUTE_PATH.SCHEDULE_HISTORY,
    component: PeerScheduleHistory,
  },
  {
    path: ROUTE_PATH.PEERSONA_CHAT_LOGS,
    component: PeersonaChatLogs,
  },
  {
    path: ROUTE_PATH.TEMPLATES_COMMS,
    component: TemplateComms,
  },
  {
    path: ROUTE_PATH.CHECKINS,
    component: Checkins,
  },
  {
    path: ROUTE_PATH.REQUESTS,
    component: Requests,
  },
  {
    path: ROUTE_PATH.DEMOGRAPHICS,
    component: Demographics,
  },
  {
    path: ROUTE_PATH.PROJECT_MANAGEMENT,
    component: RichTextEditor,
  },
  {
    path: ROUTE_PATH.BLACKLIST,
    component: blacklist,
  },
  {
    path: ROUTE_PATH.BLOCKED,
    component: CallerBlockList,
  },
  {
    path: ROUTE_PATH.USER_MANAGEMENT,
    component: UserManagement,
  },
  {
    path: ROUTE_PATH.LISTENERS_PROFILE,
    component: Profile,
  },
  {
    path: ROUTE_PATH.LISTENERS_CONTENT_REVIEW,
    component: ContentReview,
  },
  {
    path: ROUTE_PATH.PEERS_PROFILE,
    component: Profile,
  },
  {
    path: ROUTE_PATH.PEERS_CONTENT_REVIEW,
    component: ContentReview,
  },
  {
    path: ROUTE_PATH.PEER_PEERSONA,
    component: Peersona,
  },
  {
    path: ROUTE_PATH.LISTENERS_ENGAGEMENT,
    component: Engagement,
  },
  {
    path: ROUTE_PATH.PEERS_ENGAGEMENT,
    component: Engagement,
  },
  {
    path: ROUTE_PATH.LISTENERS_CONNECTION,
    component: Connections,
  },
  {
    path: ROUTE_PATH.LISTENERS_AVAILABLE,
    component: Additional,
  },
  {
    path: ROUTE_PATH.LISTENER_AUDIO_REVIEW,
    component: ProfileAudioReview,
  },
  {
    path: ROUTE_PATH.PEER_AUDIO_REVIEW,
    component: ProfileAudioReview,
  },
  {
    path: ROUTE_PATH.LISTENER_VIDEO_REVIEW,
    component: ProfileVideoReview,
  },
  {
    path: ROUTE_PATH.PEER_VIDEO_REVIEW,
    component: ProfileVideoReview,
  },
  {
    path: ROUTE_PATH.PEER_PAYOUT,
    component: Payout,
  },
  {
    path: ROUTE_PATH.LISTENER_PAYOUT,
    component: Payout,
  },
  {
    path: ROUTE_PATH.LISTENERS_LOG,
    component: Log,
  },
  {
    path: ROUTE_PATH.PEER_LOG,
    component: Log,
  },
  {
    path: ROUTE_PATH.LISTENERS_ON_CALL,
    component: OnCall,
  },
  {
    path: ROUTE_PATH.MEMBERS,
    component: Members,
  },
  {
    path: ROUTE_PATH.MEMBERS_PROFILE,
    component: MembersProfile,
  },
  {
    path: ROUTE_PATH.MEMBERS_CONNECTIONS,
    component: MemberConnections,
  },
  {
    path: ROUTE_PATH.MEMBERS_LOG,
    component: MemberLog,
  },
  {
    path: ROUTE_PATH.SETTINGS,
    component: Settings,
  },
  {
    path: ROUTE_PATH.CALLS,
    component: Calls,
  },
  {
    path: ROUTE_PATH.STORIES,
    component: Stories,
  },
  {
    path: ROUTE_PATH.TOPICS,
    component: Topics,
  },
  {
    path: ROUTE_PATH.GROUPS,
    component: Clients,
  },
  {
    path: ROUTE_PATH.GROUPS_PACKAGES,
    component: Packages,
  },
  {
    path: ROUTE_PATH.GROUPS_CONFIGURE,
    component: Configure,
  },
  {
    path: ROUTE_PATH.GROUPS_ELIGIBILITY,
    component: EligibilityFile,
  },
  {
    path: ROUTE_PATH.GROUPS_RESOURCES,
    component: ClientResources,
  },
  {
    path: ROUTE_PATH.GROUPS_ADMINS,
    component: Admins,
  },
  {
    path: ROUTE_PATH.GROUPS_SSO_CONFIGURATION,
    component: SSOConfiguration,
  },
  {
    path: ROUTE_PATH.GROUPS_PEERSONA_CONFIGURATION,
    component: ClientPeersonaConfig,
  },
  {
    path: ROUTE_PATH.REPORTING,
    component: Reporting,
  },
  {
    path: ROUTE_PATH.ELIGIBILITY_TOOL,
    component: EligibilityTool,
  },
  // {
  //   path: ROUTE_PATH.THEME_CONFIGURATION,
  //   component: ThemeConfiguration,
  // },
  {
    path: ROUTE_PATH.DEFAULT_CONTENT,
    component: DefaultThemeConfiguration,
  },
  {
    path: ROUTE_PATH.TIERS,
    component: Tiers,
  },
  {
    path: ROUTE_PATH.TIER_DETAILS,
    component: TiersDetails,
  },
  {
    path: ROUTE_PATH.TAGS,
    component: Tags,
  },
  {
    path: ROUTE_PATH.TAG_GROUPS,
    component: TagGroups,
  },
  {
    path: ROUTE_PATH.CONTENT_LIBRARY,
    component: ContentLibrary,
  },
  {
    path: ROUTE_PATH.AUDIO_SAMPLES,
    component: AudioSamplesPage,
  },
  {
    path: ROUTE_PATH.RESOURCES,
    component: Resources,
  },
  {
    path: ROUTE_PATH.SYSTEM_USERS,
    component: Users,
  },
  {
    path: ROUTE_PATH.MEMBERSTOC,
    component: MemberTOS,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.CLIENTADMINTOC,
    component: ClientAdminTOS,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.LISTENRFAQTOC,
    component: ListenerTOS,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.VERSIONED_AGREEMENTS,
    component: VersionedAgreements,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.PEERSONA_CRISIS_DEFAULTS,
    component: PeersonaCrisisDefaults,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.AI_PROMPTS,
    component: AIPrompts,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.FI_CONCIERGE,
    component: FiConcierge,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.FILES,
    component: Files,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.AUDIO_REVIEW,
    component: AudioReview,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.VIDEO_REVIEW,
    component: VideoReview,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.PROFILE,
    component: AvatarReview,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.ABOUT_ME,
    component: AboutMeReview,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.DISPLAY_NAME,
    component: DisplayNameReview,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.BACKGROUND_TAGS,
    component: BackgroundTagApproval,
    role: UserRole.admin,
  },
  {
    path: ROUTE_PATH.RESOURCES_DETAILS,
    component: ResourceDetails,
  },
  { path: ROUTE_PATH.CALLS_REPORT, component: CallReporting, id: 'Reports' },
  { path: ROUTE_PATH.ENGAGEMENTS_REPORT, component: EngagementReporting, id: 'Reports' },
  { path: ROUTE_PATH.CLIENT_ENGAGEMENTS_REPORT, component: ClientEngagementReporting, id: 'Reports' },
  { path: ROUTE_PATH.TAMU_REPORT, component: TAMUReport, id: 'Reports' },
  { path: ROUTE_PATH.FEATURE_FLAGS, component: FeatureFlagsPage },
  { path: ROUTE_PATH.PIPELINES, component: PipelinesPage },
  { path: ROUTE_PATH.PERSONAS, component: PersonasCatalog },
  { path: ROUTE_PATH.PERSONAS_SHARED_RULES, component: SharedRules },
  { path: ROUTE_PATH.PERSONA_OVERVIEW, component: PersonaOverview },
  { path: ROUTE_PATH.PERSONA_CLIENTS, component: PersonaClients },
  { path: ROUTE_PATH.PERSONA_RULES, component: PersonaRules },
  { path: ROUTE_PATH.PERSONA_EVALS, component: PersonaEvals },
  { path: ROUTE_PATH.PERSONA_PROMPTS, component: PersonaPrompts },
  { path: ROUTE_PATH.PERSONA_CHAT, component: PersonaChat },
];

export const AdminRouter = () => {
  return (
    <Switch>
      {/* here is how you can navigate someone to where they need to go  */}
      <Route exact path="/" render={() => <Redirect to={ROUTE_PATH.DASHBOARD} />} />
      <Route exact path={ROUTE_PATH.LOGIN} render={() => <Redirect to={ROUTE_PATH.DASHBOARD} />} />
      {/* the layout of the pages are inside the private route for some reason :( */}
      {adminRoutes.map((route) => (
        <PrivateRoute exact component={route.component} path={route.path} />
      ))}
      {clientAdminRoutes.map((route) => (
        <PrivateRoute exact path={route.path} component={route.component} />
      ))}
      {publicRoutes.map((route) => (
        <Route path={route.path} component={route.component} />
      ))}
      <Route exact path="*" render={() => <Redirect to={ROUTE_PATH.DASHBOARD} />} />
    </Switch>
  );
};
